import React, { useState} from "react";
import { HamburgerSpin } from "react-animated-burgers";
import styled, {css} from "styled-components";

const Burger = styled(HamburgerSpin)`
  position: absolute;
  width: 50px;
  height: 50px;
  right: 30px;
  top: 23px;
  z-index: 4;
  outline: none;
`;

const DropDown = styled.div`
    width: 100%;
    height: 400px;
    background-color: white;
    position: absolute;
    transform: translate(0, -100%);
    z-index: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: transform 0.3s ease-in;
    ${({open}) => 
        open &&
        css`
         transform: translate(0, 0);
    `}

`

const Category = styled.a`
    width: 100%;
    text-align: center;
    font-size: 21px;
    padding: 0.7rem;
    color: black;
    text-decoration: none;
`;

function Hamburger() {

  const [open, setOpen] = useState(false);

  function handleClick() {
    setOpen((prev) => !prev);
  }


  return( 
      <>
    <Burger isActive={open} toggleButton={handleClick} barColor={open ? "black" : "white"} />
    <DropDown open={open}>
        <Category href="https://www.opentable.com/la-boite-en-bois">Reservation</Category>
        <Category href="#menu">Menu</Category>
        <Category href="#about">About Us</Category>
        <Category href="#hours">Hours</Category>
        <Category href="#hours">Location</Category>
        <Category href="#photos">Photos</Category>
        <Category href="#">Contact</Category>
    </DropDown>
    </>
  )
}

export default Hamburger;
